import { RouteName } from '@/constants/RouteName';

/**
 * Set of special auth-related routes.
 *
 * The type includes `| null | undefined` to satisfies typescript's RouteName.
 * In runtime, `.has(null)` must return `false`.
 */
export const SKIP_AUTH_ROUTES = new Set<string | null | undefined>([
  RouteName.LOGIN, // Allow admin to login without that modal
  RouteName.LOGOUT, // This will get redirected away like immediately
  RouteName.UNAUTHORIZED,
]);

/**
 * Whether AuthRoot should leave the current URL alone.
 *
 * `currentRouteName` is null until the initial navigation resolves, and it may
 * never: `applyPermissionGuard` does not call `next()` while the user is unknown.
 * Fall back to the name matched from the browser path so `/login` still skips
 * and gated pages still redirect.
 */
export function shouldSkipUnauthRedirect({
  currentRouteName,
  resolvedNameFromPath,
}: {
  currentRouteName: string | symbol | null | undefined;
  resolvedNameFromPath: string | symbol | null | undefined;
}): boolean {
  return SKIP_AUTH_ROUTES.has((currentRouteName ?? resolvedNameFromPath) as string);
}
